import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39e2b43a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e2b43a')) {
      api.createRecord('39e2b43a', component.options)
    } else {
      api.reload('39e2b43a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39e2b43a", function () {
      api.rerender('39e2b43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/type/index.vue"
export default component.exports